
<div class="roles">
  <label for="cname">Select Role (choose Owner, Street, Surveyor, or Other)</label>
  <!--<dx-tooltip target="#img"
              showEvent="dxhoverstart"
              hideEvent="dxhoverend">
    <div *dxTemplate="let data of 'content'">
      <span>
        <b>Plan Roles:</b><br /><br />
        <p>
          In addition to Owner, you may select Street, Surveyor, or Local (Local may refer to a subdivision or other common name).
        </p>
      </span>
    </div>
  </dx-tooltip>-->
  <div class="select-container">
    <select class="select" name="roles" [(ngModel)]="utilityobj.planroleID">
      <option value="0">Owner</option>
      <option value="1">Street</option>
      <option value="2">Surveyor</option>
      <option value="3">Local</option>
    </select>
  </div>
</div>



